<template>
  <div class="inquiry-checkout">
    <site-header :inverted="isMobile" />
    <div class="d-flex flex-column justify-center align-center">
      <v-form class="mb-4" ref="save" lazy-validation @submit.prevent="save">
        <v-row>
          <v-col cols="12" sm="12" md="12" class="pb-0">
            <v-text-field
              v-model="inquiry.full_name"
              name="full_name"
              tabindex="1"
              label="Full Name"
              type="text"
              outlined
              dense
              :rules="[required]"
              required
            />
          </v-col>
          <v-col cols="12" sm="12" md="12" class="py-0">
            <v-text-field
              v-model="inquiry.email"
              name="email"
              tabindex="1"
              label="Email"
              type="text"
              outlined
              dense
              :rules="emailRules"
            />
          </v-col>
          <v-col cols="12" sm="12" md="12" class="py-0">
            <phone-input
              v-model="inquiry.phone"
              name="phone"
              tabindex="1"
              label="Phone"
              type="text"
              outlined
              dense
              :rules="[required]"
            />
          </v-col>
          <v-col cols="12" sm="12" md="12" class="py-0">
            <v-textarea
              v-model="inquiry.note"
              outlined
              placeholder="comments..."
              style="min-height: 100px"
              rows="4"
              cols="15"
            >
            </v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <div class="d-flex justify-center align-center my-3">
              <v-btn
                block
                large
                :color="actionsColor"
                class="white--text rounded-lg"
                elevation="0"
                type="submit"
                :loading="isLoading"
              >
                Send
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import SiteHeader from "@/components/header/site-header.vue";
import DeviceMixin from "@/mixins/device-mixin";
import FormRules from "@/mixins/form-rules-mixin";
import PhoneInput from "@/components/common/phone-input.vue";
import stylesMixin from "@/mixins/styles-mixin";

export default {
  name: "inquiry-checkout",
  components: {
    SiteHeader,
    PhoneInput,
  },
  props: ["listing", "currentPricing"],
  mixins: [DeviceMixin, FormRules, stylesMixin],
  data() {
    return {
      isLoading: false,
      inquiry: {
        full_name: "",
        email: "",
        phone: "",
        note: "",
      },
    };
  },
  methods: {
    async save() {
      if (!this.$refs.save.validate()) return;
      this.isLoading = true;
      this.$emit("save", this.inquiry);
    },
  },
};
</script>
